import { render, staticRenderFns } from "./SwatchColors.vue?vue&type=template&id=42c52cd9&scoped=true&"
import script from "./SwatchColors.vue?vue&type=script&lang=js&"
export * from "./SwatchColors.vue?vue&type=script&lang=js&"
import style0 from "./SwatchColors.vue?vue&type=style&index=0&id=42c52cd9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c52cd9",
  null
  
)

export default component.exports